import { Badge, Col, Row } from "react-bootstrap"
import { BATTLE_RESULT } from "../../constants/Common";
import useMapInfo from "../../hooks/useMapInfo";


const CharacterMap = ({ playerId}) => {
    const { map } = useMapInfo(playerId)
    const joinStatus = (status) => {
        let bgColor = 'secondary'
        if (status == BATTLE_RESULT.WIN) {
            bgColor = 'success'
        } else if (status == BATTLE_RESULT.DEFENSER) {
            bgColor = 'danger'
        } else {
            bgColor = 'secondary'
        }
        return (
            <Badge bg={bgColor}>{BATTLE_RESULT[status]}</Badge>
        )
    }


    return (
        <>
            <Row >
                <span className="text-start h5 text-info">MAP</span>
            </Row>
            <Row className="align-items-center text-nowrap py-2 border-bottom justify-content-between">
                <Col xs="auto" className="fw-bold">
                    {joinStatus(map.status)}
                </Col>
                <Col xs="auto">
                    <span>{map.object || ' '}</span>
                </Col>
                <Col xs="auto" className="d-none d-sm-block text-muted">
                    {map.playerSlot && <span>{map.playerSlot} player</span>}
                </Col>
                <Col xs="auto" className="d-none d-md-block text-muted">
                    {map.timeStamp && <span>{map.timeStamp}</span>}
                </Col>
            </Row>
        </>
    )
}

export default CharacterMap